import { createContext, useContext } from "react";
import { assert } from "utils";

import { type MetricsRepository } from "src/repositories/metrics/MetricsRepository";
export const MetricsRepositoryContext = createContext<MetricsRepository | null>(
  null,
);
export function useMetricsRepository() {
  const repository = useContext(MetricsRepositoryContext);
  assert(repository, "MetricsRepositoryContext is missing");
  return repository;
}
